import React from 'react';
import { useForm } from 'react-hook-form';

const FormRegister = (props) => {
  const { updateStoreStateHandler, countriesData } = props;
  const {
    register,
    formState: { errors },
    handleSubmit
  } = useForm();

  function submitstoreState(e) {
    updateStoreStateHandler(e);
  }

  function RenderErrorMessage({ errorMessage }) {
    return (
      <span
        className="border border-danger rounded-circle bg-danger text-white text-center mx-1 my-auto"
        style={{ width: '2rem' }}
        title={errorMessage}
      >
        {'!'}
      </span>
    );
  }

  return (
    <form className="ps-form--auth" onSubmit={handleSubmit(submitstoreState)}>
      <div className="w-100 py-2">
        <h5>{'Become An Aasaan Affiliate'}</h5>
      </div>
      <div className="w-100">
        <div
          className={`form-group my-2 d-flex ${errors.firstName && errors.firstName.type === 'required'
            ? 'border border-danger rounded'
            : ''
            }`}
        >
          <input
            className="form-control"
            {...register('firstName', {
              required: true,
              pattern: {
                value: /^[A-Za-z]{1,50}$/,
                message: 'Enter a valid First Name'
              }
            })}
            //defaultValue={storeState.firstName}
            placeholder="First Name"
          />
          {errors.firstName && errors.firstName.type === 'pattern' && (
            <RenderErrorMessage errorMessage={errors.firstName.message} />
          )}
        </div>
      </div>
      <div className="w-100">
        <div
          className={`form-group my-2 d-flex ${errors.lastName && errors.lastName.type === 'required'
            ? 'border border-danger rounded'
            : ''
            }`}
        >
          <input
            className="form-control"
            {...register('lastName', {
              required: true,
              pattern: {
                value: /^[A-Za-z]{1,50}$/,
                message: 'Enter a valid Last Name'
              }
            })}
            //defaultValue={storeState.lastName}
            placeholder="Last Name"
          />
          {errors.lastName && errors.lastName.type === 'pattern' && (
            <RenderErrorMessage errorMessage={errors.lastName.message} />
          )}
        </div>
      </div>
      <div className="w-100">
        <div
          className={`form-group my-2 d-flex ${errors.mobileNumber && errors.mobileNumber.type === 'required'
            ? 'border border-danger rounded'
            : ''
            }`}
        >
          <input
            className="form-control"
            {...register('mobileNumber', {
              required: true,
              pattern: {
                value: /^(\+{0,1})([0-9]{10})$/,
                message: 'Enter a valid Phone Number'
              }
            })}
            //defaultValue={storeState.mobileNumber}
            placeholder="Phone Number"
          />
          {errors.mobileNumber && errors.mobileNumber.type === 'pattern' && (
            <RenderErrorMessage errorMessage={errors.mobileNumber.message} />
          )}
        </div>
      </div>
      <div className="w-100">
        <div
          className={`form-group my-2 d-flex ${errors.email && errors.email.type === 'required'
            ? 'border border-danger rounded'
            : ''
            }`}
        >
          <input
            className="form-control"
            {...register('email', {
              required: true,
              pattern: {
                value: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
                message: 'Enter a valid Email'
              }
            })}
            //defaultValue={storeState.email}
            placeholder="Email"
          />
          {errors.email && errors.email.type === 'pattern' && (
            <RenderErrorMessage errorMessage={errors.email.message} />
          )}
        </div>
      </div>
      <div className="w-100">
        <div
          className={`form-group my-2 d-flex ${errors.addressLine1 && errors.addressLine1.type === 'required'
            ? 'border border-danger rounded'
            : ''
            }`}
        >
          <input
            className="form-control"
            {...register('addressLine1', {
              required: true,
              pattern: {
                value: /^[a-zA-Z\d\-_.,\s]{1,50}$/,
                message: 'Enter a valid Address'
              }
            })}
            //defaultValue={storeState.addressLine1}
            placeholder="Address Line1"
          />
          {errors.addressLine1 && errors.addressLine1.type === 'pattern' && (
            <RenderErrorMessage errorMessage={errors.addressLine1.message} />
          )}
        </div>
      </div>
      <div className="w-100">
        <div className="form-group my-2 d-flex">
          <input
            className="form-control"
            {...register('addressLine2', {
              pattern: {
                value: /^[a-zA-Z\d\-_.,\s]{1,50}$/,
                message: 'Enter a valid Address'
              }
            })}
            //defaultValue={storeState.addressLine2}
            placeholder="Address Line2 (Optional)"
          />
          {errors.addressLine2 && errors.addressLine2.type === 'pattern' && (
            <RenderErrorMessage errorMessage={errors.addressLine2.message} />
          )}
        </div>
      </div>
      <div className="w-100">
        <div className="form-group row">
          <div
            className={`col col-6 pr-1 ${errors.country && errors.country.type === 'required'
              ? 'border border-danger rounded'
              : ''
              }`}
          >
            <select
              className="ps-select form-control"
              {...register('country', { required: true })}
            >
              <option value="">{'Select'}</option>
              <option value="IN">{'India'}</option>
            </select>
          </div>
          <div
            className={`col col-6 pl-1 ${errors.state && errors.state.type === 'required'
              ? 'border border-danger rounded'
              : ''
              }`}
          >
            <select
              className="ps-select form-control"
              {...register('state', { required: true })}
            >
              <option >{'Select'}</option>
              {countriesData && countriesData.states && countriesData.states.map((stateData) => (
                <option value={stateData.code}>{stateData.name}</option>
              ))}

            </select>
          </div>
        </div>
      </div>
      <div className="w-100">
        <div className="form-group my-2 d-flex">
          <div
            className={`d-flex mx-1 ${errors.city && errors.city.type === 'required'
              ? 'border border-danger rounded'
              : ''
              }`}
          >
            <input
              className="form-control"
              {...register('city', {
                required: true,
                pattern: {
                  value: /^[A-Za-z]{1,50}$/,
                  message: 'Enter a valid City'
                }
              })}
              //defaultValue={storeState.city}
              placeholder="City"
            />
            {errors.city && errors.city.type === 'pattern' && (
              <RenderErrorMessage errorMessage={errors.city.message} />
            )}
          </div>
          <div
            className={`d-flex mx-1 ${errors.postcode && errors.postcode.type === 'required'
              ? 'border border-danger rounded'
              : ''
              }`}
          >
            <input
              className="form-control"
              {...register('postcode', {
                required: true,
                pattern: {
                  value: /^(\+{0,1})([0-9]){1,10}$/,
                  message: 'Enter a valid Post Code'
                }
              })}
              //defaultValue={storeState.postcode}
              placeholder="Post Code"
            />
            {errors.postcode && errors.postcode.type === 'pattern' && (
              <RenderErrorMessage errorMessage={errors.postcode.message} />
            )}
          </div>
        </div>
      </div>

      <div className="w-100 pb-1">
        <button className="btn btn-dark w-100" type="submit">
          {'Sign up now'}
        </button>
      </div>
      <div className="w-100">
        <p className="font-weight-lighter text-dark m-0">
          <span>{"By completing the registration, you're accepting our "}</span>
          <span className="text-underline">
            {'Terms & Conditions and Privacy Policy'}
          </span>
        </p>
      </div>
    </form>
  );
};

export default FormRegister;
